/**
 * I-6 戰情同步異常清單（streams DLQ）。
 */

import { apiFetch } from './core';

/** DLQ 篩選狀態。 */
export type StreamsDlqStatus = 'open' | 'resent' | 'ignored' | 'all';

/** 戰情事件 DLQ row — 對齊 BE warroom-push.service.ts listDlq()。 */
export interface StreamsDlqEntry {
  id: string;
  event_id: string;
  event_type: string;
  producer_id: string;
  failure_class: string;
  retry_count: number;
  first_failed_at: string;
  last_failed_at: string;
  status: string;
  last_response: unknown;
}

/**
 * GET /admin/streams/dlq — 戰情同步異常清單（AC-I-6）。
 *
 * status 預設 'open'（未處理）；'all' 列全部。
 */
export function listStreamsDlq(
  status: StreamsDlqStatus = 'open',
): Promise<{ items: StreamsDlqEntry[] }> {
  const qs = new URLSearchParams({ status });
  return apiFetch<{ items: StreamsDlqEntry[] }>(`/admin/streams/dlq?${qs.toString()}`, {
    method: 'GET',
  });
}

/** POST /admin/streams/dlq/:id/resend — 手動重送 DLQ 事件（需 streams.dlq.manage）。 */
export function resendStreamsDlq(id: string): Promise<{ resent: boolean; outcome: string }> {
  return apiFetch<{ resent: boolean; outcome: string }>(
    `/admin/streams/dlq/${encodeURIComponent(id)}/resend`,
    { method: 'POST' },
  );
}

/** POST /admin/streams/dlq/:id/ignore — 標記 DLQ 事件為忽略（需 streams.dlq.manage）。 */
export function ignoreStreamsDlq(id: string): Promise<{ ignored: boolean }> {
  return apiFetch<{ ignored: boolean }>(`/admin/streams/dlq/${encodeURIComponent(id)}/ignore`, {
    method: 'POST',
  });
}
